<template>
  <el-row class="nofull userCenterTop">
    <el-row :gutter="20">
      <el-col :span="8" style="display: flex" class="userCenter_user_info_box">
        <div style="width: 100px">
          <el-image
            :src="
              '/forum-pub-api/v1/minio/getFile?file_url=' + currentUser.avatar
            "
            style="
              width: 80px;
              height: 80px;
              border-radius: 50%;
              overflow: hidden;
            "
            fit="cover"
          >
            <div slot="error" class="image-slot" style="height: 100%">
              <img
                class="el-image__inner"
                style="object-fit: cover"
                src="../assets/avatar_empty.jpg"
              />
            </div>
          </el-image>
        </div>
        <div
          style="
            text-align: left;
            font-size: 13px;
            line-height: 20px;
            margin-top: 10px;
          "
        >
          <div>{{ currentUser.true_name }}</div>
          <div>{{ currentUser.reg_email }}</div>
          <div>{{ currentUser.description }}</div>
          <el-link type="primary" @click="quitLogin">退出登录</el-link>
        </div>
      </el-col>
      <el-col :span="16" class="userCenter_event_info_box">
        <el-row :gutter="20" type="flex" class="row-bg" justify="end">
          <el-col :span="8">
            <el-card
              shadow="never"
              style="
                background-color: #ffa652;
                border-color: #ff8f00;
                cursor: pointer;
              "
              @click.native="gotoMyEvents"
            >
              <div>我参加过的会议</div>
              <div class="bigfont">{{ forumStats.register_count }}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card
              shadow="never"
              style="
                background-color: #5a93e5;
                border-color: #3c7ede;
                cursor: pointer;
              "
              @click.native="gotoMyEvents"
            >
              <div>我投过的稿件数</div>
              <div class="bigfont">{{ forumStats.manuscript_count }}</div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { getForumStats } from '@/apis/forumStats';

export default {
  name: 'UserCenterTop',
  computed: {
    isLogin: {
      get() {
        return this.$store.state.toGetCurrentUser.isLoginKey;
      },
    },
    currentUser: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUser;
      },
    },
  },
  mounted() {
    console.log('12', this.currentUser.avatar);
    //if(this.isLogin===0){
    //    this.openLoginBox();
    //}
    // 用户投稿、报名统计
    getForumStats()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            this.forumStats = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
          console.log(res.data);
        } else {
          this.$message.error('未请求成功');
          console.log('错误');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      fit: 'cover',
      forumStats: {},
      item: {},
    };
  },
  methods: {
    openLoginBox() {
      this.$store.commit('blOpenLoginBox', true);
      // this.$emit("openLoginBox", true)
    },
    quitLogin() {
      localStorage.removeItem('eleToken');
      this.$store.commit('AddIsLogin', 0);
      this.$router.push('/');
    },
    gotoMyEvents() {
      this.$router.push('/myEvents');
    },
  },
};
</script>

<style scoped></style>
